import React from "react";
import { observer } from "mobx-react";
import { Group, Text, Stack, Box, Card } from "@mantine/core";
import { IconProps } from "@tabler/icons-react";
import {
  showBtcAmount,
  convertSatsToFiatString,
} from "../../helpers/conversions";
import { Cubby } from "../../stores/Cubby";
import { TextWithInfo } from "../modals/textWithInfo";
import { useMediaQuery } from "@mantine/hooks";

interface ShowBalanceRowSmallProps {
  icon: React.ComponentType<IconProps>;
  label: string;
  amount: number;
  cubby: Cubby;
  infoLink?: string;
}

const ShowBalanceRowSmall: React.FC<ShowBalanceRowSmallProps> = observer(
  ({ icon: Icon, label, amount, cubby, infoLink }) => {
    const isMobile = useMediaQuery("(max-width: 768px)");
    const formattedAmount =
      amount !== null ? showBtcAmount(amount, cubby) : "-";
    const fiatAmount =
      amount !== null ? convertSatsToFiatString(amount, cubby, isMobile) : "-";

    if (isMobile) {
      // Render card only if formattedAmount is valid
      // return null
      // if (formattedAmount === "-") {
      //   return null;
      // }
      // return (
      //   <Card shadow="sm" padding="md" radius="md" withBorder mb="sm">
      //     <Group spacing="xs" align="center">
      //       <Icon size="1rem" />
      //       <TextWithInfo
      //         textSize="md"
      //         text={label}
      //         infoLink={infoLink || "https://docs.megalithic.me"}
      //       />
      //     </Group>
      //     <Stack gap="xs" mt="xs">
      //       <Text weight={500}>{formattedAmount}</Text>
      //       <Text color="dimmed">{fiatAmount}</Text>
      //     </Stack>
      //   </Card>
      // );
      return null;
    } else {
      // Desktop (table row) layout
      return (
        <tr>
          <td>
            <Group gap="xs">
              <Icon size="1.1rem" />
              <Text size="md">{label}</Text>
              {/* <TextWithInfo
                textSize="md"
                text={label}
                infoLink={infoLink || "https://docs.megalithic.me"}
              /> */}
            </Group>
          </td>
          <td>{formattedAmount}</td>
          <td>{fiatAmount}</td>
        </tr>
      );
    }
  }
);

export default ShowBalanceRowSmall;
